module.exports = __webpack_public_path__ + "static/media/icon-top-of-mind.faa25462.svg";